import styled from 'styled-components';
import DialogActions from '@material-ui/core/DialogActions';

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
`;

export const Fader = styled.div`
  opacity: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
  &[data-anim='done'] {
    opacity: 0;
  }
`;

export const TutorialStepsWrapper = styled.div`
  button {
    margin: 5px 5px 0 0;
  }
`;

export const CustomDialogActions = styled(DialogActions)`
  padding: 15px;
`;
